import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Model from "./Model";
import { useAuth } from "../context/UserContext";
import toast from "react-hot-toast";

const Header = ({ setToken }) => {
  const [open, setOpen] = useState(false);
  const [mobileMenuShow, setMobileMenuShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(1);
  const { user } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const location = useLocation();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setMobileMenuShow(!mobileMenuShow);
  };

  const closeMenuOnLinkClick = () => {
    setMobileMenuShow(false);
  };
  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("token");
      setIsAuthenticated(!!token);
    };

    checkToken();
    window.addEventListener("storage", checkToken);
    window.addEventListener("tokenUpdate", checkToken);

    return () => {
      window.removeEventListener("storage", checkToken);
      window.removeEventListener("tokenUpdate", checkToken);
    };
  }, []);
  useEffect(() => {
    const header = document.querySelector("header");
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuShow(false);
        header.style.height = "auto";
      }
    };

    if (mobileMenuShow) {
      header.classList.add("menu-open");
      header.style.height = `${window.innerHeight}px`;
      document.body.style.overflow = "hidden";
    } else {
      header.classList.remove("menu-open");
      header.style.height = "auto";
      document.body.style.overflow = "auto";
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileMenuShow]);
  useEffect(() => {
    const handleResize = () => {
      const header = document.querySelector("header");
      const body = document.body;
      const osw = document.querySelector(".owl-slide-wrapper");
      if (window.innerWidth <= 992) {
        header.classList.add("header-mobile");
        if (body.classList.contains("side-content")) {
          body.classList.remove("side-layout");
        }

        if (osw) {
          const imgs = osw.querySelectorAll("img");
          imgs.forEach((img) => {
            img.style.height = `${window.innerHeight}px`;
            img.style.width = "auto";
          });

          if (window.$op_header_autoshow === 1) {
            header.classList.remove("autoshow");
          }
        }
      } else {
        header.classList.remove("header-mobile");
        if (body.classList.contains("side-content")) {
          body.classList.add("side-layout");
        }

        if (osw) {
          const imgs = osw.querySelectorAll("img");
          imgs.forEach((img) => {
            img.style.width = "100%";
            img.style.height = "auto";
          });

          if (window.$op_header_autoshow === 1) {
            header.classList.add("autoshow");
          }
        }
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("Cart");
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    toast.success("logout Successfully");
    setStep(1);

    navigate("/");
    window.dispatchEvent(new Event("tokenUpdate"));
  };
  return (
    <>
      <div id="wrapper">
        <div className="scrollbar-v show-on-scroll"></div>
        <header className="bg-white has-topbar">
          {/* style={{ boxShadow: "0px 0px 10px 1px black" }} */}
          <div id="topbar" style={{ backgroundColor: "#73b734" }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between xs-hide">
                    <div className="d-flex align-items-center">
                      <div className="topbar-widget me-5">
                        <a href="#">
                          <i className="icofont-location-pin"></i>Gaitor Road,
                          Jagatpura, Jaipur, Rajasthan-302017
                        </a>
                      </div>
                      <div className="topbar-widget me-5">
                        <a href="#" className="d-flex me-2">
                          <i className="icofont-envelope"></i>
                          support@atyourdoormobilerepairs.com
                        </a>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="social-icons">
                        <a
                          href="https://www.facebook.com/people/AtyourDoor/61570062873490/"
                          target="_blank"
                        >
                          <i className="fa-brands fa-facebook fa-lg"></i>
                        </a>
                        <a
                          href="https://www.instagram.com/atyourdoormobilerepairs/"
                          target="_blank"
                        >
                          <i className="fa-brands fa-instagram fa-lg"></i>
                        </a>
                        <a href="#">
                          <i className="fa-brands fa-x-twitter fa-lg"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container header-box-shadow">
            <div className="row">
              <div className="col-md-12">
                <div className="de-flex sm-pt10">
                  <div className="de-flex-col">
                    <div id="logo">
                      <Link to="/">
                        <img
                          className="logo-main"
                          src="/assets/images/logo-light/Mobile_logo.png"
                          alt=""
                          style={{ width: "120px" }}
                        />
                        <img
                          className="logo-scroll"
                          src="/assets/images/logo-light/Mobile_logo.png"
                          alt=""
                          style={{ width: "100px" }}
                        />
                        <img
                          className="logo-mobile"
                          src="/assets/images/logo-light/Mobile_logo.png"
                          alt=""
                          style={{ width: "120px", height: "45px" }}
                        />
                      </Link>
                    </div>
                  </div>
                   
                  <div
                    className={`d-flex-col header-col-mid  ${
                      mobileMenuShow ? "mobile-menu-active" : ""
                    }`}
                  >
                    
                    <ul
                      id="mainmenu"
                      className={mobileMenuShow ? "show-menu" : "hide-menu"}
                      onClick={closeMenuOnLinkClick}
                    >
                      <li>
                        <Link
                          className={`menu-item ${
                            location.pathname === "/brands"
                              ? "active"
                              : ""
                          }`}
                          style={{
                            color:
                              location.pathname === "/brands"
                                ? "#2d3777"
                                : "#73b734",
                            fontWeight: "400",
                          }}
                          to="/brands"
                        >
                          BOOK A REPAIR
                        </Link>
                      </li>

                      <li>
                        <Link
                          className={`menu-item ${
                            location.pathname === "/service" ? "active" : ""
                          }`}
                          style={{
                            color:
                              location.pathname === "/service"
                                ? "#2d3777"
                                : "#73b734",
                            fontWeight: "400",
                          }}
                          to="/service"
                        >
                          SERVICES
                        </Link>
                      </li>

                      <li
                        className={` ${isOpen ? "show" : ""}`}
                        onMouseEnter={() => setIsOpen(true)}
                        onMouseLeave={() => setIsOpen(false)}
                      >
                        <Link
                          to="/at-your-door-store"
                          className={`menu-item atyoutdoorlink  ${
                            location.pathname === "/at-your-door-store"
                              ? "active"
                              : ""
                          }`}
                          style={{
                            color:
                              location.pathname === "/at-your-door-store"
                                ? "#2d3777"
                                : "#73b734",
                            fontWeight: "400",
                          }}
                          id="navbarDropdown"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded={isOpen}
                          onClick={() => setIsOpen(!isOpen)}
                        >
                          ATYOURDOOR STORE{" "}
                          {isOpen ? (
                            <i className="fa fa-angle-up"></i>
                          ) : (
                            <i className="fa fa-angle-down"></i>
                          )}
                        </Link>
                        <ul
                          className={`dropdown-menu ${isOpen ? "show" : ""}`}
                          aria-labelledby="navbarDropdown"
                        >
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/at-your-door-store"
                            >
                              Jaipur
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link
                          className={`menu-item ${
                            location.pathname === "/blog" ? "active" : ""
                          }`}
                          style={{
                            color:
                              location.pathname === "/blog"
                                ? "#2d3777"
                                : "#73b734",
                            fontWeight: "400",
                          }}
                          to="/blog"
                        >
                          BLOG
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`menu-item ${
                            location.pathname === "/contact" ? "active" : ""
                          }`}
                          style={{
                            color:
                              location.pathname === "/contact"
                                ? "#2d3777"
                                : "#73b734",
                            fontWeight: "400",
                          }}
                          to="/contact"
                        >
                          CONTACT US
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="de-flex-col">
                    <div className="menu_side_area text-dark">
                      <span
                        id="menu-btn"
                        onClick={toggleMenu}
                        className={
                          mobileMenuShow ? "menu-open text-dark" : "text-dark"
                        }
                      ></span>
                    </div>
                    <div id="btn-extra" className="mt-0">
                      <span>
                        {!isAuthenticated ? (
                          <Link
                            style={{
                              backgroundColor: "#73b734",
                              fontWeight: "400",
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#loginModal"
                            className="btn-topbar bg-color rounded text-light"
                            to="/login"
                          >
                            Login
                          </Link>
                        ) : (
                          <div
                            className="position-relative d-inline-block"
                            style={{ top: "-10px" }}
                          >
                            <div
                              className="d-flex align-items-center gap-2 px-3 py-2"
                              onClick={() => setOpen(!open)}
                              style={{
                                cursor: "pointer",
                                borderRadius: "5px",
                              }}
                              onMouseEnter={() => setOpen(true)}
                              onMouseLeave={() => setOpen(false)}
                            >
                              <span
                                className="fw-bold text-capitalize "
                                style={{ color: "#73b734" }}
                              >
                                {" "}
                                <i className="fa-solid fa-user"></i>{" "}
                                {user?.[0]?.f_name || ""}{" "}
                                {open ? (
                                  <i className="fa fa-angle-up"></i>
                                ) : (
                                  <i className="fa fa-angle-down"></i>
                                )}
                              </span>
                            </div>

                            {/* Dropdown Menu */}
                            {open && (
                              <div
                                className="position-absolute bg-white shadow rounded py-2 profilelink "
                                style={{
                                  top: "calc(100% + 5px)",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  minWidth: "200px",
                                  zIndex: 1000,
                                }}
                                onMouseEnter={() => setOpen(true)}
                                onMouseLeave={() => setOpen(false)}
                              >
                                {[
                                  {
                                    name: "Orders",
                                    icon: "fa-box",
                                    route: "/order",
                                  },
                                  // { name: "Saved Payments", icon: "fa-credit-card", route: "/saved-payment" },
                                  {
                                    name: "Saved Address",
                                    icon: "fa-map-marker-alt",
                                    route: "/saved-address",
                                  },
                                  {
                                    name: "My Earnings",
                                    icon: "fa-wallet",
                                    route: "/my-earning",
                                  },
                                  {
                                    name: "Log Out",
                                    icon: "fa-sign-out-alt",
                                    action: handleLogout,
                                  },
                                ].map((item, index) => (
                                  <li
                                    key={index}
                                    className="px-3 py-2 d-flex align-items-center"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "14px",
                                      transition: "background 0.2s, color 0.2s",
                                      fontWeight:
                                        index === 0 ? "bold" : "normal",
                                      color: index === 4 ? "black" : "inherit",
                                    }}
                                    onClick={() => {
                                      setOpen(false);
                                      if (item.action) {
                                        item.action();
                                      } else {
                                        navigate(item.route);
                                      }
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.background = "#f1f1f1";
                                      if (index === 4)
                                        e.target.style.color = "red";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.background = "transparent";
                                      if (index === 4)
                                        e.target.style.color = "black";
                                    }}
                                  >
                                    <i className={`fas ${item.icon} me-2`}></i>{" "}
                                    {item.name}
                                  </li>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
      {/* model  */}
      <Model step={step} setStep={setStep} setToken={setToken} />
    </>
  );
};

export default Header;
